<template>
  <v-sheet id="dashboard-container" class="mt-6">
    <div ref="iframeContainer" :style="`height: ${usableHeight}px;`">
      <iframe
        ref="dashboardIframe"
        frameborder="0"
        width="100%"
        height="100%"
        :src="dashboardUrl"
      ></iframe>
    </div>
  </v-sheet>
</template>
  
  <script>
export default {
  name: "dashboard",
  data: () => ({
    usableHeight: 0,

    dashboardUrl:
      "https://analytics.zoho.com/open-view/2576060000000936681/5593dba9738470f22fe7473d380aaef3",
  }),
  mounted() {
    this.calculateUsableHeight();
    window.addEventListener("resize", this.calculateUsableHeight);

    // Listen for postMessage events from the iframe
    window.addEventListener("message", (event) => {
      if (event.data && event.data.type === "adjustHeightResponse") {
        const iframe = this.$refs.dashboardIframe;

        // Set the height of the iframe based on the received data
        iframe.style.height = event.data.height + "px";
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateUsableHeight);
  },
  methods: {
    calculateUsableHeight() {
      const headerComponent = document.getElementById("smc-app-header");
      const dashboardContainer = document.getElementById("dashboard-container");

      const headerHeight = headerComponent.offsetHeight;
      const containerRect = dashboardContainer.getBoundingClientRect();

      this.usableHeight = window.innerHeight - containerRect.top - headerHeight;
    },
  },
};
</script>
  